import React from "react";

const DL_ICON = "/images/security/download_vector.svg";

export default function OrderHistoryDownloadButtons({ onDownload, stacked = false }) {
  return (
    <button type="button" className={`so-dlBtn${stacked ? " w-100" : ""}`} onClick={onDownload}>
      <img src={DL_ICON} alt="" aria-hidden="true" />
      Download
    </button>
  );
}
